import React, { memo } from 'react';
import Element from '../../element';
import styles from './checkbox.module.scss';

interface IProps {
    children?: React.ReactNode;
    disabled?: boolean;
    checked?: boolean;
    onChange?: (evt: any) => any;
    name?: string;
    htmlFor?: string;
}

function Checkbox({ children, disabled = false, checked, ...rest }: IProps) {
    return (
        <Element
            className={styles['checkbox']}
            renderAs="label"
            disabled={disabled}
        >
            <Element
                type="checkbox"
                renderAs="input"
                disabled={disabled}
                checked={checked}
                {...rest}
            />
            <Element className={styles['checkbox-label']}>{children}</Element>
        </Element>
    );
}

export default memo(Checkbox);
